<template>
  <Spacer
    :spacing-grid="mappedSpacerHeight"
    v-bind="
      ContentfulLivePreview.getProps({
        entryId: item.sys.id,
        fieldId: 'spacerHeight'
      })
    "
  />
</template>

<script setup lang="ts">
import { Spacer } from '@hypercodestudio/basler-components';
import type { SpacingGrid } from '@hypercodestudio/basler-components/dist/components/elements/Spacer.vue';
import type { ISpacer, ISpacerFields } from '~/lib/ContentfulService';
import { ContentfulLivePreview } from '@contentful/live-preview';

interface Props {
  item: ISpacer;
}

const props = defineProps<Props>();

const spacerHeightMap: Partial<
  Record<ISpacerFields['spacerHeight'], SpacingGrid>
> = {
  xxxlarge: 'xxlarge'
};

const mappedSpacerHeight = computed(() => {
  return (spacerHeightMap[props.item.fields.spacerHeight] ??
    props.item.fields.spacerHeight) as SpacingGrid;
});
</script>
